// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O55n","colMin":"styles_colMin__23XMx"};